var Marionette = require('backbone.marionette');

var HelpOfficeAdminView = Marionette.View.extend({
    template: require('../../templates/help/help-office-admin-view.html'),

    initialize: function(options){
    }

});


module.exports = HelpOfficeAdminView;


//////////////////
// WEBPACK FOOTER
// ./app/views/help/help-office-admin-view.js
// module id = 505
// module chunks = 0